import request from "@/http";
const insertPublicityOfferData = (data) => {
  let { id_public_middle_table,is_online,mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004,mid_table_remark_005,mid_table_remark_006,mid_table_remark_007,mid_table_remark_008,mid_table_remark_009,mid_table_remark_010,mid_table_remark_011,mid_table_remark_012,mid_table_remark_013,mid_table_remark_014,mid_table_remark_015,mid_table_remark_016,mid_table_remark_017,mid_table_remark_018,mid_table_remark_019,mid_table_remark_020,mid_table_remark_021,mid_table_remark_022,id_public_user_info, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      id_public_user_info: id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_003: mid_table_remark_003,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_006: mid_table_remark_006,
      mid_table_remark_007: mid_table_remark_007,
      mid_table_remark_008: mid_table_remark_008,
      mid_table_remark_009: mid_table_remark_009,
      mid_table_remark_010: mid_table_remark_010,
      mid_table_remark_011: mid_table_remark_011,
      mid_table_remark_012: mid_table_remark_012,
      mid_table_remark_013: mid_table_remark_013,
      mid_table_remark_014: mid_table_remark_014,
      mid_table_remark_015: mid_table_remark_015,
      mid_table_remark_016: mid_table_remark_016,
      mid_table_remark_017: mid_table_remark_017,
      mid_table_remark_018: mid_table_remark_018,
      mid_table_remark_019: mid_table_remark_019,
      mid_table_remark_020: mid_table_remark_020,
      mid_table_remark_021: mid_table_remark_021,
      mid_table_remark_022: mid_table_remark_022,
      pre_db_para_middle_table_name: "public_middle_table_80006",
      type_middle_app: 80006,
      type_inner_app: 1002,
      is_online: is_online ? is_online : 0,
    },
    loading: {
      enabled: isloading
    }
  })
}
const getPublicityOfferData = (data) => {
  let { begin_idx, limit, id_public_middle_table, pre_db_para_order_by_para, is_online, id_public_user_info, mid_table_remark_001, mid_table_remark_013, mid_table_remark_018, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_80006",
      pre_db_para_order_by_para: pre_db_para_order_by_para ? pre_db_para_order_by_para : 'id_public_middle_table desc',
      id_public_middle_table: id_public_middle_table,
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: 80006,
      type_inner_app: 1002,
      is_online_in: is_online,
      id_public_user_info: id_public_user_info,
      mid_table_remark_001_like: mid_table_remark_001,
      mid_table_remark_013: mid_table_remark_013,
      mid_table_remark_018_in: mid_table_remark_018
    },
    loading: {
      enabled: isloading
    }
  })
}
const getPublicityData = (data) => {
  let { begin_idx, limit, id_public_middle_table, pre_db_para_order_by_para, is_online, mid_table_remark_001, mid_table_remark_002, mid_table_remark_003, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_80006",
      pre_db_para_order_by_para: pre_db_para_order_by_para ? pre_db_para_order_by_para : 'id_public_middle_table desc',
      id_public_middle_table: id_public_middle_table,
      pre_db_para_begin_idx: begin_idx,
      pre_db_para_length_4_list: limit,
      type_middle_app: 80006,
      type_inner_app: 1001,
      is_online_in: is_online,
      mid_table_remark_001_like: mid_table_remark_001,
      mid_table_remark_002_in: mid_table_remark_002,
      mid_table_remark_003_in: mid_table_remark_003
    },
    loading: {
      enabled: isloading
    }
  })
}
export default {
  insertPublicityOfferData,
  getPublicityOfferData,
  getPublicityData
}
